export const extractValueFromOrderTags = (key, xs = []) => {
    const z = xs && xs.find((x) => x && x.indexOf(key) === 1);
    if (!z)
        return '';
    return z.slice(key.length + 3, z.length - 1);
};
